import React from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function PainAmplification() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-dark py-16 md:py-24" data-id="element-312">
      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6 text-gray-200 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-313">
        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-314">
          Piénsalo un momento.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-315">
          Si llevas 3 años haciendo taxes... y cada año dejaste ir aunque sea
          $500, $800, o $1,200 que podías haber reclamado...
        </p>

        <div className="bg-navy-light p-6 md:p-8 rounded-xl border-l-4 border-gold-primary shadow-lg my-8" data-id="element-316">
          <p className="text-2xl md:text-3xl font-bold text-gold-light font-heading leading-snug" data-id="element-317">
            Estamos hablando de $1,500 a $3,600 o más que salieron de tu
            bolsillo sin que lo supieras.
          </p>
        </div>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-318">
          Dinero para la renta. Para el carro. Para darles algo mejor a tus
          hijos. Para salir un poco adelante.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed font-bold text-white" data-id="element-319">
          Ese dinero no desapareció. Sigue ahí. Esperando.
        </p>

        <div className="bg-red-900/20 p-6 rounded-xl border border-red-500/20 my-4" data-id="element-320">
          <p className="text-xl md:text-2xl leading-relaxed text-red-300 font-semibold" data-id="element-321">
            Pero tiene fecha de vencimiento.
          </p>
        </div>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-322">
          El IRS solo te permite ir 3 años hacia atrás para reclamar lo que te
          deben.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed font-semibold text-white" data-id="element-323">
          Cada año que pasa sin actuar... es dinero que se evapora para siempre.
        </p>
      </div>
    </section>;
}